module.exports = __webpack_public_path__ + "img/d6.4e64aa47.png";